var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EA5455"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5613 39.938C42.843 40.2198 43.0014 40.602 43.0014 41.0005C43.0014 41.399 42.843 41.7812 42.5613 42.063C42.2795 42.3448 41.8973 42.5031 41.4988 42.5031C41.1002 42.5031 40.718 42.3448 40.4363 42.063L32.5 34.1242L24.5613 42.0605C24.2795 42.3423 23.8973 42.5006 23.4988 42.5006C23.1002 42.5006 22.718 42.3423 22.4363 42.0605C22.1545 41.7787 21.9962 41.3965 21.9962 40.998C21.9962 40.5995 22.1545 40.2173 22.4363 39.9355L30.375 31.9992L22.4388 24.0605C22.157 23.7787 21.9987 23.3965 21.9987 22.998C21.9987 22.5995 22.157 22.2173 22.4388 21.9355C22.7205 21.6537 23.1027 21.4954 23.5013 21.4954C23.8998 21.4954 24.282 21.6537 24.5638 21.9355L32.5 29.8742L40.4388 21.9342C40.7205 21.6524 41.1027 21.4941 41.5013 21.4941C41.8998 21.4941 42.282 21.6524 42.5638 21.9342C42.8455 22.216 43.0039 22.5982 43.0039 22.9967C43.0039 23.3953 42.8455 23.7775 42.5638 24.0592L34.625 31.9992L42.5613 39.938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.db2c2a574f134c172ee63c0b7d688c96.svg";
export { ForwardRef as ReactComponent };